import { jsxs, jsx } from 'react/jsx-runtime';

const SvgArrowDropdownCircle = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z" }), jsx("path", { fill: "#2D2E2E", d: "m7 11.4 5 4.6 5-4.6V9l-5 4.6L7 9v2.4Z" })] }));

export { SvgArrowDropdownCircle as default };
//# sourceMappingURL=ArrowDropdownCircle.es.js.map
